import React from 'react'

export const Loading = () => <div className="loadingSplash">Loading...</div>
